import { AppBar, Box, Toolbar, styled } from '@mui/material';
import { get } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { PAGES_URLS } from 'src/lib/constants/routes';
import { AUTH_TOKEN_DATA } from 'src/lib/constants/constant';
import { removeDataKeys, removeNullDeep } from 'src/utils/helper';
import { useAuthentication } from '../../context/AuthContext';
import GetRecords from '../../lib/api/GetRecords';
import { APIS } from '../../lib/constants/apis';
import BroadcastNachricht from '../ui-component/broadcast-nachricht/BroadcastNachricht';
import DesktopHeader from './header-components/DesktopHeader';
import MobileHeader from './header-components/MobileHeader';

export const StyledToolbar = styled(Toolbar)({
	display: 'flex',
	justifyContent: 'space-between',
});
export const NavLinksContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	[theme.breakpoints.up('lg')]: {
		position: 'absolute',
		left: '50%',
		transform: 'translateX(-50%)',
		maxWidth: 1140,
	},
}));
export const NavLinkStyled = styled(NavLink)(({ theme }) => ({
	padding: theme.spacing(2.8, 2),
	color: theme.palette.navbar.primary.main,
	textDecoration: 'none',
	borderBottom: `2px solid transparent`,
	'&.active': {
		color: theme.palette.navbar.primary.active,
		borderBottom: `2px solid ${theme.palette.navbar.primary.active}`,
	},
}));

const BROADCAST_HIDDEN_PAGES = [
	PAGES_URLS.FoerderProgramm,
	PAGES_URLS.Impressum,
	PAGES_URLS.Datenschutz,
	PAGES_URLS.Kontakt,
	PAGES_URLS.BarrierefreiheitMelden,
	PAGES_URLS.ErklaerungZurBarrierefreiheit,
];

function Header() {
	const location = useLocation();
	const { authenticatedData, isAuthenticated, logout } = useAuthentication();
	const [unreadMessageCount, setUnreadMessageCount] = useState(0);
	const [broadcastData, setBroadcastData] = useState([]);

	const showBroadcast = useMemo(() => {
		return !BROADCAST_HIDDEN_PAGES.some((page) => location.pathname === page || location.pathname.startsWith(page + '/'));
	}, [location.pathname]);

	useEffect(() => {
		const fetchNachricht = async () => {
			try {
				let fields = ['id'];
				let filterOption = {
					Antragsteller: { id: { $eq: get(authenticatedData, AUTH_TOKEN_DATA.organisationId) } },
					Allgemein_Ordner: 'Posteingang',
					Allgemein_gelesen: 'false',
				};
				let pagination = {
					start: 0,
					limit: 1,
					withCount: true,
				};
				let res = await GetRecords(APIS['Portal-Nachricht'], [], filterOption, [], pagination, fields);
				setUnreadMessageCount(get(res, 'meta.pagination.total', 0));
			} catch (err: any) {
				const errorData = JSON.parse(err.message);
				if (get(errorData, 'error.status') === 403 || get(errorData, 'error.status') === 401) {
					logout();
				}
				console.error('ERROR: Fetching Nachrichten ', err);
			}
		};

		const fetchBroadcastNachricht = async () => {
			try {
				const filter = {
					Allgemein_Beginnt: { $lte: new Date() },
					Allgemein_Endet: { $gte: new Date() },
				};
				let res = await GetRecords(APIS.boradcastNachricht, [], filter);
				if (res) {
					setBroadcastData(removeNullDeep(removeDataKeys(get(res, 'data', []))));
				}
			} catch (err: any) {
				console.error('ERROR: Fetching Broadcast-Nachricht', err);
			}
		};

		if (isAuthenticated) {
			fetchNachricht();
			fetchBroadcastNachricht();
		}
	}, [authenticatedData, isAuthenticated, location, logout]);

	if (isAuthenticated) {
		return (
			<>
				<AppBar position='sticky'>
					<Box sx={{ display: { xs: 'none', md: 'block' } }}>
						<DesktopHeader unreadMessageCount={unreadMessageCount} />
					</Box>
					<Box sx={{ display: { xs: 'block', md: 'none' } }}>
						<MobileHeader />
					</Box>
				</AppBar>
				{showBroadcast && <BroadcastNachricht data={broadcastData} />}
			</>
		);
	}
	return <></>;
}

export default Header;
